import { useTranslate } from '@festina-life/ui/hooks'
import { useParams } from 'react-router'

import type { AnyConfigurationRouteParams } from '../../system/types'
import { useApplicationViewOperationsContext } from '../../workspace/applicationViewOperationsContext'

export const useCurrentPackageName = () => {
  const translate = useTranslate()
  const { templateId, parameterDefinitionId, registeredTenantId, enumId } =
    useParams<AnyConfigurationRouteParams>()
  const { applicationTemplates, applicationParameterDefinitions } =
    useApplicationViewOperationsContext()

  if (templateId) {
    return applicationTemplates.get(templateId)?.lastEntity?.packageName
  } else if (parameterDefinitionId) {
    return applicationParameterDefinitions.get(parameterDefinitionId)
      ?.lastParameterEntity?.packageName
  } else if (enumId) {
    return translate('enumsTree.fallbackPackage.enums')
  } else if (registeredTenantId) {
    return translate('tenantsTree.fallbackPackage.tenants')
  }

  return undefined
}
